export const selectWorkshopAppointmentTemplates = (state) => state.workshopAppointmentTemplates.workshopAppointmentTemplates;
export const selectWorkshopAppointmentTemplatesLoading = (state) => state.workshopAppointmentTemplates.loading;